import React, { useCallback, useEffect, useState } from 'react'
import { FaClock, FaLock, FaLockOpen, FaRegTrashAlt, FaSearch } from 'react-icons/fa'
import { IoIosArrowForward } from 'react-icons/io'
import { useIntl } from 'react-intl'
import { payslipTranslate } from '../../i18n/translatedMessages'
import { Select } from '../Employee/Select/Select'
import PaySlipResult from './payslipResult'
import DownloadPayslip from './downloadPayslip'
import SendPayslip from './sendPayslip'
import Payroll from '../../API/Payroll/Payroll.js'
import List from '../../API/Lists/Lists.js'
import countryMapper from '../../Utils/CountriesMapper.js'
import Loading from '../Loading/Loading'

const monthsList = [
	{ id: 1, value: 'Enero' },
	{ id: 2, value: 'Febrero' },
	{ id: 3, value: 'Marzo' },
	{ id: 4, value: 'Abril' },
	{ id: 5, value: 'Mayo' },
	{ id: 6, value: 'Junio' },
	{ id: 7, value: 'Julio' },
	{ id: 8, value: 'Agosto' },
	{ id: 9, value: 'Septiembre' },
	{ id: 10, value: 'Octubre' },
	{ id: 11, value: 'Noviembre' },
	{ id: 12, value: 'Diciembre' },
]

const statusList = [
	{ id: 'false', value: 'Abierto' },
	{ id: 'true', value: 'Cerrado' },
]

const monthsListTranslate = [
	{ id: 1, value: { es: 'Enero', pt: 'Janeiro' } },
	{ id: 2, value: { es: 'Febrero', pt: 'Fevereiro' } },
	{ id: 3, value: { es: 'Marzo', pt: 'Março' } },
	{ id: 4, value: { es: 'Abril', pt: 'Abril' } },
	{ id: 5, value: { es: 'Mayo', pt: 'Maio' } },
	{ id: 6, value: { es: 'Junio', pt: 'Junho' } },
	{ id: 7, value: { es: 'Julio', pt: 'Julho' } },
	{ id: 8, value: { es: 'Agosto', pt: 'Agosto' } },
	{ id: 9, value: { es: 'Septiembre', pt: 'Setembro' } },
	{ id: 10, value: { es: 'Octubre', pt: 'Outubro' } },
	{ id: 11, value: { es: 'Noviembre', pt: 'Novembro' } },
	{ id: 12, value: { es: 'Diciembre', pt: 'Dezembro' } },
]

const PaySlip = () => {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'
	const user = JSON.parse(localStorage.getItem('user'))
	const companyId = window.location.pathname.includes('employee/nomina') ? user.companyId : user.id
	const [loading, setLoading] = useState(true)
	const [showPaySlip, setShowPaySlip] = useState(false)
	const [payslipData, setPayslipData] = useState(null)
	const [payslipList, setPayslipList] = useState()
	const [countries, setCountries] = useState([])
	const [filters, setFilters] = useState({
		year: '',
		status: '',
		month: '',
		country: '',
	})

	const getMonthTranslate = (id, language = 'es') => {
		let month

		if (typeof id === 'string' && id.match(/^\d{2}$/)) {
			id = parseInt(id, 10)
		}

		if (typeof id === 'number') {
			month = monthsListTranslate.find(m => m.id === id)
		} else if (typeof id === 'string') {
			month = monthsListTranslate.find(m => m.value.pt.toLowerCase() === id.toLowerCase())
		}

		if (!month) return 'Mês inválido'

		return month.value[language] || 'Mês inválido'
	}

	const handleCloseResult = () => {
		setShowPaySlip(false)
		setPayslipData(null)
	}

	const fetchData = useCallback(async () => {
		setLoading(true)

		const { year, status, month, country } = filters

		try {
			const [resPayslipList, respCountries] = await Promise.all([Payroll.getPayrollList(companyId, month, year, country, status), List.countries()])
			setPayslipList(resPayslipList)
			setCountries(
				respCountries.map(countryMapper.toDomain).sort((a, b) => {
					if (a.value === 'Chile') return -1
					if (b.value === 'Chile') return 1
					return a.value.localeCompare(b.value)
				})
			)
		} catch (error) {
			console.error('Error:', error)
		} finally {
			setLoading(false)
		}
	}, [filters])

	useEffect(() => {
		fetchData()
	}, [fetchData])

	const handleFilter = e => {
		const selectedOption = e.target.value
		setFilters(prev => ({
			...prev,
			[e.target.name]: selectedOption || null,
		}))
	}
	const cleanFilters = () => {
		setFilters({
			year: '',
			status: '',
			month: '',
			country: '',
		})
	}

	const handleUploadSuccess = () => {
		fetchData()
	}

	return (
		<>
			{!showPaySlip && (
				<>
					<div className='tw-flex tw-justify-between tw-items-start tw-ml-16 2xl:tw-ml-10 22xl:tw-ml-0 tw-mr-6 2xl:tw-mr-16  tw-text-sm 2xl:tw-text-base'>
						<div className='tw-max-w-3xl tw-mr-5 '>
							<h3 className='tw-mb-4 tw-font-bold'>{payslipTranslate.payslipTitle}</h3>
							<div className='tw-mb-5 tw-w-full '>{payslipTranslate.payslipDesc}</div>
						</div>
						<div className='2xl:tw-flex tw-space-y-2 2xl:tw-space-y-0 2xl:tw-space-x-2'>
							<DownloadPayslip />
							<SendPayslip
								language={language}
								monthList={monthsList}
								countryList={countries}
								onUploadSuccess={handleUploadSuccess}
								companyId={companyId}
							/>
						</div>
					</div>
					<div className='tw-flex tw-justify-between  tw-space-x-3 tw-items-center tw-ml-16 2xl:tw-ml-10 tw-mr-6 2xl:tw-mr-16 tw-text-sm 2xl:tw-text-base tw-mb-5'>
						<div className='tw-w-full'>
							<Select placeholder='Pais' list={countries} onChange={handleFilter} name='country' value={filters.country} />
						</div>

						<div className='tw-h-[45px] tw-w-full border tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-px-3 tw-cursor-pointer'>
							<input
								type='month'
								name='month'
								value={filters.month ? `${filters.year}-${filters.month}` : ''}
								onChange={e => {
									const [year, month] = e.target.value.split('-')
									setFilters({ ...filters, month, year })
								}}
								className='tw-border-none tw-bg-transparent tw-text-gray-700 tw-w-full tw-outline-none'
							/>
						</div>

						<div className='tw-w-full'>
							<Select placeholder='Status' list={statusList} onChange={handleFilter} name='status' value={filters.status} />
						</div>

						<button
							className={`tw-w-[9%] tw-text-sm tw-flex tw-px-1 tw-items-center tw-justify-center tw-mt-1 ${
								Object.values(filters).some(filter => filter) ? 'tw-bg-purple-500 tw-text-white' : 'tw-text-gray-400'
							}`}
							style={{ height: 45, border: '1px solid #CBD5E1', borderRadius: 8 }}
							onClick={cleanFilters}
							disabled={Object.values(filters).every(filter => filter === '')}
						>
							<FaRegTrashAlt className='me-1' size={12} />
							Limpiar
						</button>
					</div>
				</>
			)}

			{showPaySlip && <PaySlipResult onCloseResult={handleCloseResult} payslipData={payslipData} language={language} />}

			{loading ? (
				<Loading />
			) : (
				!showPaySlip && (
					<div className='tw-space-y-3 tw-text-sm 2xl:tw-text-base'>
						{Array.isArray(payslipList) && payslipList.length > 0 ? (
							payslipList.map((item, index) => (
								<div className='border tw-p-4  tw-ml-16 2xl:tw-ml-10 22xl:tw-ml-0  tw-mr-6 2xl:tw-mr-16 tw-rounded-xl ' key={index}>
									<div className='tw-flex tw-justify-between tw-items-center'>
										<div className='tw-flex tw-items-center tw-space-x-3'>
											{item.status === true ? (
												<div className='tw-flex tw-items-center tw-rounded-full tw-bg-gray-200 tw-px-3 tw-py-1 tw-text-sm tw-min-w-[100px]'>
													<FaLock className='tw-mr-2' size={14} />
													{payslipTranslate.payslipClosed}
												</div>
											) : (
												<div className='tw-flex tw-items-center tw-rounded-full tw-bg-green-100 tw-px-3 tw-py-1 tw-text-sm tw-min-w-[100px]'>
													<FaLockOpen className='tw-mr-2' size={14} />
													{payslipTranslate.payslipOpen}
												</div>
											)}
											<div className='tw-flex tw-items-center tw-space-x-3'>
												<div className='tw-font-bold'>{getMonthTranslate(item.month, language)}</div>
												<div className='tw-text-gray-500'>{item.year}</div>
												<div className='tw-text-gray-500'>{countries.find(c => c.id === item.countryId)?.value}</div>
											</div>
										</div>

										<div className='tw-flex tw-items-center tw-space-x-9'>
											{item.status === false && (
												<div className='tw-flex tw-items-center'>
													<div className='tw-text-gray-500'>Status</div>
													<div className='tw-font-black tw-flex tw-items-center'>
														<FaClock size={14} className='tw-mr-1 tw-ml-2' />
														{payslipTranslate.payslipRevision}
													</div>
												</div>
											)}
											<div
												className='tw-text-purple-500 tw-flex tw-items-center tw-cursor-pointer'
												onClick={() => {
													setShowPaySlip(true)
													setPayslipData(item)
												}}
											>
												{payslipTranslate.payslipShowProccess} <IoIosArrowForward className='tw-ml-1' size={14} />
											</div>
										</div>
									</div>
								</div>
							))
						) : (
							<div className='tw-text-center tw-text-base tw-text-gray-400 tw-py-12'>{payslipTranslate.payslipNoData}</div>
						)}
					</div>
				)
			)}
		</>
	)
}

export default PaySlip
